import React from "react";
import ReactDOM from "react-dom/client";

import { RecentProducts } from "@app/scripts/react-recent-products/components/RecentProducts";

class RecentProductsElem extends HTMLElement {
  connectedCallback() {
    const columnsDesktop = this.getAttribute("columns-desktop") ? parseInt(this.getAttribute("columns-desktop")) : 5;
    const columnsMobile = this.getAttribute("columns-mobile") ? parseInt(this.getAttribute("columns-mobile")) : 1;
    const disabledMobileSlider = this.getAttribute("disabled-mobile") == "true";
    const disabledDesktopSlider = this.getAttribute("disabled-mobile") == "true";
    const transparentButtons = this.getAttribute("transparent-btns") == "true";

    const root = ReactDOM.createRoot(this);
    root.render(
      <RecentProducts
        columnsDesktop={columnsDesktop}
        columnsMobile={columnsMobile}
        disabledMobileSlider={disabledMobileSlider}
        disabledDesktopSlider={disabledDesktopSlider}
        transparentButtons={transparentButtons}
      />
    );
  }
}

customElements.define("recent-products", RecentProductsElem);
